<template>
    <div class="w-full text-center pb-10">
        <h2 v-text="$t('NUMBER_OF_MONTHS_SELECTOR_AND_HOW')"></h2>
        <div class="slider" v-if="isSliderVisible">
            <div class="gifting__slide">
                <input
                    type="range"
                    :min="minAllowedMonths"
                    :max="maxAllowedMonths"
                    v-model.number="sliderValue"
                    class="slider focus:outline-none">

                <span class="gifting__min" v-text="minString"></span>
                <span class="gifting__max" v-text="maxString"></span>
            </div>
            <div>
                <p>
                    <input
                        class="border border-black gifting__slide--box-input py-2 mr-3"
                        type="number"
                        :min="minAllowedMonths"
                        :max="maxAllowedMonths"
                        v-model="sliderValue">
                    <span v-text="monthText"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'NumberOfMonthsSelector',
    data() {
        return {
            sliderValue: 0,
        };
    },
    created() {
        setTimeout(() => {
            this.sliderValue = this.numberOfMonths;
        }, 250);
    },
    methods: {
        /**
         * Trigger event to parent component about updated number of deliveries.
         *
         * @param {Number|null} value
         *
         * @returns {void}
         */
        updateNumberOfDeliveries(value) {
            this.$store.commit('gifting/setSubscriptionNumberOfMonths', value);
        },
    },
    computed: {
        ...mapGetters({
            minAllowedMonths: 'gifting/getSubscriptionMinimumDeliveryMonthsAllowed',
            maxAllowedMonths: 'gifting/getSubscriptionMaximumDeliveryMonthsAllowed',
            numberOfMonths: 'gifting/getNumberOfMonthsForSubscription',
        }),

        monthText() {
            return this.sliderValue > 1 ? this.$t('NUMBER_OF_MONTHS_SELECTOR_MONTHS') : this.$t('NUMBER_OF_MONTHS_SELECTOR_MONTH');
        },

        minString() {
            return `${this.minAllowedMonths} ${this.$t('NUMBER_OF_MONTHS_SELECTOR_MIN')}`;
        },

        maxString() {
            return `${this.maxAllowedMonths} ${this.$t('NUMBER_OF_MONTHS_SELECTOR_MAX')}`;
        },

        isSliderVisible() {
            return this.numberOfMonths > 0;
        },

        selectedPlan() {
            return this.$store.getters['gifting/getFrequencyForSubscription'];
        },
    },
    watch: {
        sliderValue(to) {
            const months = parseInt(to);

            if (months >= this.minAllowedMonths && months <= this.maxAllowedMonths) {
                this.updateNumberOfDeliveries(months);
            } else {
                this.sliderValue = Math.min(this.maxAllowedMonths, Math.max(this.maxAllowedMonths, months));
            }
        },

        selectedPlan() {
            this.sliderValue = this.minAllowedMonths;
        },
    },
};
</script>
